export function locationHasChanged(l1, l2) {
  return l1.pathname !== l2.pathname || l1.search !== l2.search || l1.hash !== l2.hash;
}
